export class ListMPAPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<MPAPolicy>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMPAPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
